<template>
    <el-form
        :model="form"
        :rules="rules"
        ref="registerCompany"
        label-width="130px"
        label-position="right"
        size="small"
        status-icon>
        <!-- 标题 -->
        <el-form-item>
            <span>{{$t("message.register.title1")}}</span>
        </el-form-item>
        <!-- ID -->
        <!-- <el-form-item 
            :label="$t('message.register.id')">
            <el-input 
                :value="form.id"
                disabled>
            </el-input>
        </el-form-item> -->
        <!-- 用户名 -->
        <el-form-item 
            :label="$t('message.register.username')" 
            prop="username">
            <el-popover
                placement="right-start"
                trigger="focus">
                <ul class="register-company-popover">
                    <li>{{$t('message.register.unameNorm1')}}</li>
                    <li>{{$t('message.register.unameNorm2')}}</li>
                    <li>{{$t('message.register.unameNorm3')}}</li>
                    <li>{{$t('message.register.unameNorm4')}}</li>
                </ul>
                <el-input 
                    v-model="form.username"
                    slot="reference"
                    clearable>
                </el-input>
            </el-popover>
        </el-form-item>
        <!-- 密碼 -->
        <el-form-item 
            :label="$t('message.register.pwd')"
            prop="password">
            <el-popover
                placement="right-start"
                trigger="focus">
                <ul class="register-company-popover">
                    <li>{{$t('message.register.pwdNorm1')}}</li>
                    <li>{{$t('message.register.pwdNorm2')}}</li>
                    <li>{{$t('message.register.pwdNorm3')}}</li>
                </ul>
                <el-input 
                    type="password"
                    v-model="form.password"
                    slot="reference"
                    clearable>
                </el-input>
            </el-popover>
        </el-form-item>
        <!-- 密碼確認 -->
        <el-form-item 
            :label="$t('message.register.cpwd')"
            prop="cpwd">
            <el-input 
                type="password"
                v-model="form.cpwd"
                clearable>
            </el-input>
        </el-form-item>
        <!-- 電子郵箱 -->
        <el-form-item 
            :label="$t('message.register.email')"
            prop="email">
            <el-popover
                placement="right-start"
                trigger="focus">
                <ul class="register-company-email-tips">
                    <li>{{$t("public.emailTips")}}</li>
                </ul>
                <el-input 
                    type="textarea"
                    v-model="form.email"
                    slot="reference"
                    autosize>
                </el-input>
            </el-popover>
        </el-form-item>
        <!-- 标题 -->
        <el-form-item>
            <span>{{$t("message.register.title2")}}</span>
        </el-form-item>
        <!-- 公司名稱（中） -->
        <el-form-item 
            :label="$t('message.register.companyname')"
            prop="companyname">
            <el-input 
                v-model="form.companyname"
                clearable>
            </el-input>
        </el-form-item>
        <!-- 公司名稱（英） -->
        <el-form-item 
            :label="$t('message.register.en_companyname')"
            prop="en_companyname">
            <el-input 
                v-model="form.en_companyname"
                clearable>
            </el-input>
        </el-form-item>
        <!-- 聯絡人姓名 -->
        <el-form-item 
            :label="$t('message.register.consignee')"
            prop='consignee'>
            <el-input 
                v-model="form.consignee"
                clearable>
            </el-input>
        </el-form-item>
        <!-- 聯繫電話 -->
        <el-form-item 
            :label="$t('message.register.mobile')"
            prop="mobile">
            <el-input 
                v-model="form.mobile"
                clearable>
            </el-input>
        </el-form-item>
        <!-- 公司傳真 -->
        <el-form-item 
            :label="$t('message.register.fax_company')">
            <el-input 
                v-model="form.fax"
                clearable>
            </el-input>
        </el-form-item>
        <!-- 公司地址 -->
        <el-form-item 
            :label="$t('message.register.address1')"
            prop="address">
            <el-input 
                v-model="form.address"
                clearable>
            </el-input>
        </el-form-item>
        <!-- 公司類別 -->
        <el-form-item 
            :label="$t('message.register.market')"
            prop="market">
            <el-select
                v-model="form.market"
                class="register_company_select">
                <el-option
                    v-for="(item, index) in options.markets"
                    :key="index"
                    :label="item"
                    :value="item">
                </el-option>
            </el-select>
        </el-form-item>
        <!-- 地區 -->
        <el-form-item 
            :label="$t('message.register.industry')"
            prop="industry">
            <el-select
                v-model="form.industry"
                class="register_company_select">
                <el-option
                    v-for="(item, index) in options.industrys"
                    :key="index"
                    :label="item"
                    :value="item">
                </el-option>
            </el-select>
        </el-form-item>
        <!-- 营业执照
            prop="license" -->
        <el-form-item
            :label="$t('message.register.license')">
            <el-upload
                action="#"
                list-type="picture"
                :show-file-list="false"
                :auto-upload="false"
                :multiple="false"
                :on-change="handleChange"
                class="register-upload">
                <el-image
                    :src="license_pic"
                    v-if="license_pic"
                    fit="scale-down"
                    lazy
                    class="register-upload-pic">
                    <!-- 加载中样式 -->
                    <template v-slot:placeholder>
                        <div class="image-slot">
                            <i class="el-icon-loading"></i>
                        </div>
                    </template>
                    <!-- 加载失败样式 -->
                    <template v-slot:error>
                        <div class="image-slot">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </template>
                </el-image>
                <i v-else slot="default" class="el-icon-plus register-upload-icon"></i>
            </el-upload>
        </el-form-item>
        <!-- 验证码 -->
        <el-form-item 
            :label="$t('message.register.code')" 
            prop="code">
            <el-input
                v-model="form.code"
                class="register_company_code_input">
                <template #append>
                    <a href="javascript:;"
                        class="identify_code"
                        @click="refreshCode" >
                        <s-identify 
                            :identifyCode="identifyCode"
                            canvas-id="company-code">
                        </s-identify>
                    </a>
                </template>
            </el-input>
        </el-form-item>
        <!-- 我已阅读并同意 -->
        <el-form-item>
            <el-checkbox v-model="form.isSure">{{$t("message.register.forSure")}}</el-checkbox>
            <el-button
                type="text"
                @click="handleAgreement">
                《{{$t('message.register.agreement')}}》
            </el-button>
        </el-form-item>
        <!-- 提交 -->
        <el-form-item>
            <el-button
                type="primary"
                @click="submitForm">
                <span>{{$t("public.submitBtn")}}</span>
            </el-button>
        </el-form-item>
    </el-form>
</template>

<script>
import { mapMutations, mapActions } from 'vuex'
import region from '@/utils/region'
import { uname, pwd, cpwd, code, email } from "@/utils/validate";

export default {
    data() {
        let validateUname = (rule, value, callback) => { // 用户名验证
            uname(this, rule, value, callback);
        },
        validatepwd = (rule, value, callback) => { // 密码验证
            pwd(this, "registerCompany", rule, value, callback);
        },
        validatepwd2 = (rule, value, callback) => { // 密码重复验证
            cpwd(this, rule, value, callback);
        },
        validateCode = (rule, value, callback) => { // 验证码验证
            code(this, rule, value, callback);
        },
        validateEmail = (rule, value, callback) => {
            email(this, true, value, callback);
        };
        return {
            // 验证码组
            identifyCodes: "1234567890abcdefghijklmnopqrstuvwxyz",
            // 验证码
            identifyCode: "",
            // 营业执照
            license_pic: "",
            // 表单
            form: {
                username: "",
                companyname: "",
                en_companyname: "",
                password: "",
                cpwd: "",
                email: "",
                consignee: "",
                mobile: "",
                fax: "",
                address: "",
                area: "",
                industry: "",
                market: "",
                license: "",
                code: "",
                isSure: false,
            },
            // 规则
            rules: {
                username:[
                    { required: true, validator: validateUname, trigger: [ 'blur', 'change' ] }
                ],
                companyname:[
                    { required: true, message: this.$t("message.register.errcompanyname"), trigger: 'blur' },
                ],
                en_companyname:[
                    { required: true, message: this.$t("message.register.erren_companyname"), trigger: 'blur' },
                ],
                password: [
                    { required: true, validator: validatepwd, trigger: 'blur' }
                ],
                cpwd: [
                    { required: true, validator: validatepwd2, trigger: 'blur' }
                ],
                email: [
                    { required: true, validator: validateEmail, trigger: ['blur', 'change'] }
                ],
                consignee:[
                    { required: true, message: this.$t("message.register.errconsignee"), trigger: 'blur' },
                ],
                mobile:[
                    { required: true, message: this.$t("message.register.errmobile"), trigger: 'blur' },
                ],
                fax:[
                    { required: true, message: this.$t("message.register.errfax"), trigger: 'blur' },
                ],
                address:[
                    { required: true, message: this.$t("message.register.erraddress"), trigger: 'blur' },
                ],
                industry: [
                    { required: true, message: this.$t("message.register.errindustry"), trigger: 'blur' }
                ],
                market: [
                    { required: true, message: this.$t("message.register.errmarket"), trigger: 'blur' }
                ],
                code: [
                    { required: true, validator: validateCode, trigger: 'blur'}
                ]
            },
        }
    },
    computed: {
        options(){
            let lang = localStorage.lang,
            industrys = region.cn_regions,
            markets = region.cn_type;
            if(lang == "en"){
                industrys = region.en_regions;
                markets = region.en_type;
            }
            return {
                industrys,
                markets
            }
        }
    },
    components: {
        SIdentify: () => import("@/components/identify")
    },
    methods: {
        ...mapMutations([
            "handleDialog"
        ]),
        ...mapActions([
            "sendRegister",
            "handleValidateUname",
            "getColumnContent"
        ]),
        // 验证码函数
        randomNum(min, max) {
            return Math.floor(Math.random() * (max - min) + min);
        },
        // 更换验证码函数
        refreshCode() {
            // 清空输入框
            this.form.code = "";
            // 清空生成验证码
            this.identifyCode = "";
            this.makeCode(this.identifyCodes, 4);
        },
        // 生成验证码函数
        makeCode(o, l) {
            for (let i = 0; i < l; i++) {
                this.identifyCode += this.identifyCodes[
                this.randomNum(0, this.identifyCodes.length)
                ];
            }
        },
        // 
        handleChange(file, fileList){ // 营业执照base64编码写入
            let reader = new FileReader();
            reader.onload = () => {
                let _base64 = reader.result;
                let BASE64 = _base64.split(",");
                this.form.license = BASE64[1];
                this.license_pic = file.url;
            }
            reader.readAsDataURL(file.raw)
        },
        handleAgreement(){ // 打开协议条款
            this.getColumnContent(6);
            this.handleDialog(true);
        },
        // 
        // 提交注册信息
        submitForm() {
            this.$refs.registerCompany.validate((valid) => {
                this.refreshCode();
                if (valid) {
                    // 向服务器发起请求
                    this.sendRegister(this.form).then((res)=>{
                        if(res.isRegister){
                            this.$alert(this.$t("message.register.succregister"),{
                                type:'success',
                                dangerouslyUseHTMLString:true,
                                center:true,
                                confirmButtonText: this.$t("public.goLogin"),
                                callback:action=>{
                                    this.$router.replace('/login')
                                }
                            })
                            // 清空数据
                            this.form = {
                                username: "",
                                companyname: "",
                                en_companyname: "",
                                password: "",
                                cpwd: "",
                                email: "",
                                consignee: "",
                                mobile: "",
                                fax: "",
                                address: "",
                                area: "",
                                industry: "",
                                market: "",
                                license: "",
                                code: "",
                                isSure: false,
                            }
                            this.license_pic = "";
                        }else{
                            this.$message.error(res.msg);
                        }
                    })
                } else {
                    return false;
                }
            });
        },
    },
    created() {
        // 生成验证码
        this.identifyCode = "";
        this.makeCode(this.identifyCodes, 4);
    }
}
</script>

<style scoped>
/* 注册提示弹出框 */
.register-company-popover{
    list-style-type: circle;
    padding-left: 20px;
}
/* 注册公司部分下拉选择 */
.register_company_select{
    width: 100%;
}

.register_company_code_input>>>.el-input-group__append{
    padding: 0
}
/* 营业执照 */
.register-upload>>>.el-upload{
    width: 178px;
    height: 178px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.register-upload>>>.el-upload:hover {
    border-color: #409EFF;
}
.register-upload-pic{
    width: 100%;
    height: 100%;
}
.register-upload-icon{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    font-size: 28px;
    color: #8c939d;
}
/* 验证码 */
.identify_code{
    display: inline-block;
    vertical-align: middle;
    width: 115px;
    height: 30px;
    text-align: center;
}
.register-company-email-tips{
    list-style-type: circle;
    padding-left: 20px;
    color: #909399;
}
</style>
